var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"padding-right":"20px"}},_vm._l((_vm.fields),function(item,field){return _c('el-col',{key:field,attrs:{"span":(_vm.dual && (!item.row))?12:24}},[_c('front-single-form-editor',{attrs:{"single":_vm.single,"field":field,"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }